import { createAction, props } from '@ngrx/store';

import { Error } from '@rpe/registro-personas-empresas-lib';
import { Tecnico } from './entity-tecnicos.model';

// LOAD
export const entityTecnicosLoadRequest = createAction(
  '[ENTITYTECNICOS] Load Request'
);

export const entityTecnicosLoadFailure = createAction(
  '[ENTITYTECNICOS] Load Failure',
  props<{ error: Error }>()
);

export const entityTecnicosLoadSuccess = createAction(
  '[ENTITYTECNICOS] Load Success',
  props<{ items: Tecnico[] }>()
);
